import { render, staticRenderFns } from "./LeaderBoardTableHeading.vue?vue&type=template&id=3fd9bb40&scoped=true&"
import script from "./LeaderBoardTableHeading.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardTableHeading.vue?vue&type=style&index=0&id=3fd9bb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9bb40",
  null
  
)

export default component.exports